import React from 'react'
import { Box, Button, IconButton, LinearProgress, Paper, Typography } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { advancedColors } from '../theme'
import { TourStepDefinition } from './steps'

type Props = {
  step: TourStepDefinition
  index: number
  size: number
  onBack: () => void
  onNext: () => void
  onClose: () => void
}

const TourCard = ({ step, index, size, onBack, onNext, onClose }: Props) => {
  const isLast = index === size - 1

  return (
    <Paper
      role="dialog"
      aria-modal
      aria-label={step.title}
      elevation={8}
      sx={{ width: 340, maxWidth: 'calc(100vw - 32px)', borderRadius: '16px', overflow: 'hidden' }}
    >
      <LinearProgress
        variant="determinate"
        value={((index + 1) / size) * 100}
        aria-hidden
        sx={{ height: 3, backgroundColor: advancedColors.greenSoft }}
      />
      <Box sx={{ p: 2.5, pt: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="caption" sx={{ flex: 1, color: advancedColors.inkMuted }}>
            {index + 1} of {size}
          </Typography>
          <IconButton
            size="small"
            aria-label="Close the tour"
            onClick={onClose}
            sx={{ mr: -1, color: advancedColors.inkMuted }}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Box>

        <Typography variant="subtitle1" component="h2" sx={{ mt: 0.5, fontWeight: 700, color: advancedColors.ink }}>
          {step.title}
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.75, color: advancedColors.inkMuted, whiteSpace: 'pre-line' }}>
          {step.body}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2.5 }}>
          {!isLast && (
            <Button size="small" onClick={onClose} sx={{ color: advancedColors.inkMuted, ml: -1 }}>
              Skip tour
            </Button>
          )}
          <Box sx={{ flex: 1 }} />
          {index > 0 && (
            <Button size="small" onClick={onBack}>
              Back
            </Button>
          )}
          <Button size="small" variant="contained" disableElevation autoFocus onClick={onNext}>
            {isLast ? 'Done' : 'Next'}
          </Button>
        </Box>
      </Box>
    </Paper>
  )
}

export default TourCard
